export const adaptCodigoPostal = (codigoPostalData) => {
    return {
        codigoPostal: codigoPostalData?.cP,
        localidad: codigoPostalData?.localidad,
        provincia:  codigoPostalData?.idProvinciaNavigation?.descripcion,
        tipoZona:  codigoPostalData?.idTipoZonaNavigation?.descripcion,
        idTipoZona: codigoPostalData?.idTipoZonaNavigation?.idTipoZona
    }
}

export const adaptCodigoPostalArray = (
    codigosPostalData
) => {
    return structuredClone(codigosPostalData?.allCodigoPostal?.items)
        ?.map(codigoPostal => adaptCodigoPostal(codigoPostal));
}